import { render, staticRenderFns } from "./MetricRecordForm.vue?vue&type=template&id=73ee77c6"
import script from "./MetricRecordForm.vue?vue&type=script&lang=js"
export * from "./MetricRecordForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports